import React, { useEffect, useState } from "react";

import { AppContext } from "@/AppContext";
import { AppRoutes } from "@/Routes";

import { getUserPermissions } from "./api/users";

import {
  initGA,
  isSystemDarkMode,
  logPageView,
  syncSystemDarkMode,
} from "./utils";

import { BrowserRouter } from "react-router-dom";
import { MainContentWrapper } from "./MainContentWrapper";
import { AppWrapper } from "./AppWrapper";
import { FaroProvider } from "./utils/FaroProvider";
import { focusCopilotBox } from "./Apps/AITools/askCopilot";

import { LAUNCH_OS_MARK } from "@/brand";
const App: React.FC = () => {
  // Set up state for the sidebar and right sidebar
  const [darkMode, setDarkMode] = useState<boolean>(isSystemDarkMode());
  const [sidebarOpen, setSidebarOpen] = useState<boolean>(
    // Boolean(localStorage.getItem("sidebarOpen") === "true")
    false
  );
  const [rightSidebarOpen, setRightSidebarOpen] = useState<boolean>(
    Boolean(localStorage.getItem("rightSidebarOpen") === "true")
  );
  const [copilotOpen, setCopilotOpen] = useState<boolean>(false);
  const [copilotSettings, setCopilotSettings] = useState<any>({});
  const [copilotContext, setCopilotContext] = useState<
    Record<string, unknown>[]
  >([]);
  const [currentlyViewing, setCurrentlyViewing] = useState<any[]>([]);
  const [permissions, setPermissions] = useState<string[]>([]);

  // Launch Desktop (LD-3/LD-7): the desktop app can ask this window to open the CoPilot, with or
  // without a message (a meeting note's "Draft it" from the floating panel, or the shortcut key).
  useEffect(() => {
    const desktop = (window as any).launchDesktop;
    if (!desktop || typeof desktop.onCopilot !== "function") return;
    return desktop.onCopilot(({ prompt }: { prompt?: string }) => {
      if (prompt) setCopilotContext((c: any) => ({ ...(c || {}), query: prompt }));
      setCopilotOpen(true);
      if (!prompt) focusCopilotBox(); // the shortcut: ready to type
    });
  }, []);

  const contextValue = {
    darkMode,
    sidebarOpen,
    rightSidebarOpen,
    // pluginUrls,
    permissions,
    copilotOpen,
    copilotContext,
    copilotSettings,
    currentlyViewing,
    setCurrentlyViewing,
    setPermissions,
    setDarkMode,
    setSidebarOpen,
    setRightSidebarOpen,
    setCopilotContext,
    setCopilotOpen,
    setCopilotSettings,
    // setPluginUrls,
    disableRightSidebar: true,
    app: {
      loadingImage:
        "https://s-media-cache-ak0.pinimg.com/originals/dd/67/4f/dd674f89d713bb2645a3292510219998.gif",
      logoIcon: LAUNCH_OS_MARK,
    },
  };

  // Detect when dark mode is changed and set local storage
  useEffect(() => {
    // console.log("Dark Mode Changed:", darkMode);
    localStorage.setItem("darkMode", darkMode ? "true" : "false");
    initGA("G-CMMH8E7PSL");
    logPageView();
  }, [darkMode]);

  // Listen for messages from the client iframe
  useEffect(() => {
    (async () => {
      // get user permissions
      const token = localStorage.getItem("token");
      const permissions = await getUserPermissions({ token });
      if (permissions) setPermissions(permissions);
    })();
  }, []);

  // listen for dark mode changes
  useEffect(() => {
    syncSystemDarkMode(setDarkMode);
  }, []);

  return (
    <AppContext.Provider value={contextValue}>
      <AppWrapper>
        {/* Start Main Content */}
        <div className={`main-container navbar-sticky flex`}>
          <BrowserRouter>
            <FaroProvider />
            <MainContentWrapper>
              <AppRoutes />
            </MainContentWrapper>
          </BrowserRouter>
        </div>
        {/* End Main Content */}
      </AppWrapper>
    </AppContext.Provider>
  );
};

export default App;
